import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Useletter from './Useletter';
import Foter from './Foter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Link} from 'react-router-dom'




function Slider() {
  return (
    <div>
      <Carousel data-bs-theme="dark">
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://www.junaidjamshed.com/media/weltpixel/owlcarouselslider/images/0/6/06_final.jpg"
          alt="First slide"
        />
        <Carousel.Caption>
          <h5>First slide label</h5>
          <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://www.junaidjamshed.com/media/weltpixel/owlcarouselslider/images/b/a/banner_129.jpg"
          alt="Second slide"
        />
        <Carousel.Caption>
          <h5>Second slide label</h5>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://www.junaidjamshed.com/media/weltpixel/owlcarouselslider/images/m/e/men-1.jpg"
          alt="Third slide"
        />
        <Carousel.Caption>
          <h5>Third slide label</h5>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    <br /> <br /><br />
   {/* <Container>
      <Row>
        <Col style={{marginLeft:'100px'}} ><Link to="firstpic" style={{ color: 'black', textDecoration: 'none' }}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-24.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            // objectFit:'cover',
            //  marginTop: '90px',
            // marginLeft:'40px'

        }}/></Link>
         <div>Unstitched</div>
         <div> <b>Shop Now</b> </div>
        </Col>
         <Col><Link to="secpic" style={{ color: 'black', textDecoration: 'none' }}> <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-26.jpg'
        alt=''
        style={{
            width:'43%',
            height:'auto',
            objectFit:'cover',
            //  marginTop: '90px'

        }}/> </Link><div>Unstitched</div>
         <div> <b>Shop Now</b> </div>
        
        <Col><Link to="thirpic" style={{ color: 'black', textDecoration: 'none' }}> <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-25.jpg'
        alt=''
        style={{
            width:'43%',
            height:'auto',
            objectFit:'cover',
            //  marginTop: '50px'

        }}/>  </Link><div>Unstitched</div>
         <div> <b>Shop Now</b> </div></Col>
        
        
        
        </Col>
      </Row>
    </Container> */}
    <Container>
      <Row className="gy-4 text-center">
        {/* First Image */}
        <Col xs={12} sm={6} lg={4}>
          <Link to="firstpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-24.jpg"
              alt="Unstitched"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Unstitched</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>

        {/* Second Image */}
        <Col xs={12} sm={6} lg={4}>
          <Link to="secpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-26.jpg"
              alt="Unstitched"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Unstitched</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>

        {/* Third Image */}
        <Col xs={12} sm={6} lg={4}>
          <Link to="thirpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-25.jpg"
              alt="Unstitched"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Unstitched</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>
      </Row>
    </Container>
     
    <br /> <br /><br />
    
   <Container className="text-center">
      <Row className="gy-4">
        {/* First Column */}
        <Col xs={12} md={4}>
          <Link to="forpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-19.jpg"
              alt="Kameez Shalwar"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Kameez Shalwar</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>

        {/* Second Column */}
        <Col xs={12} md={4}>
          <Link to="fivpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-31.jpg"
              alt="Sweaters"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Sweaters</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>

        {/* Third Column */}
        <Col xs={12} md={4}>
          <Link to="sixpic" style={{ color: "black", textDecoration: "none" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/W-17.jpg"
              alt="Kurta"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </Link>
          <div>Kurta</div>
          <div>
            <b>Shop Now</b>
          </div>
        </Col>
      </Row>
    </Container>
    
   
    <Container
      fluid
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "50px",
      }}
    >
      <Row style={{ justifyContent: "center" }}>
        <Col
          xs={12}
          md={10}
          lg={8}
          style={{
            backgroundColor: "#FFF8EE",
            padding: "50px",
            borderRadius: "10px",
            maxWidth: "1000px",
            width: "90%",
          }}
        >
          <div style={{ width: "100%" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/makeup_35.jpg"
              alt="Makeup"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
    <Container
      fluid
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "50px",
      }}
    >
      <Row style={{ justifyContent: "center" }}>
        <Col
          xs={12}
          md={10}
          lg={8}
          style={{
            backgroundColor: "#FFF8EE",
            padding: "50px",
            borderRadius: "10px",
            maxWidth: "1000px",
            width: "90%",
          }}
        >
          <div style={{ width: "100%" }}>
            <img
              src="https://www.junaidjamshed.com/media/wysiwyg/grooms-1.jpg"
              alt="Makeup"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </div>
        </Col>
      </Row>
    </Container>
    
          <div id="arrive" style={{fontSize:'16px',fontWeight:'400',textDecoration: 'underline'}}>NEW ARRIVALS</div>
      <div id="bg" style={{fontSize:'60px',fontWeight:'1000'}}>Boys & Girls</div>
    <Container>
  <Row>
    {/* Image 1 */}
    <Col xs={12} md={6} lg={3} style={{ textAlign: 'center' }}>
      <Link to="eighpic" style={{ color: 'black', textDecoration: 'none' }}>
        <img
          src="https://www.junaidjamshed.com/media/wysiwyg/W-7.jpg"
          alt=""
          style={{
            width: '100%', 
            height: 'auto',
            objectFit: 'cover',
            marginTop: '20px'
          }}
        />
      </Link>
    </Col>

    {/* Image 2 */}
    <Col xs={12} md={6} lg={3} style={{ textAlign: 'center' }}>
      <Link to="sevpic" style={{ color: 'black', textDecoration: 'none' }}>
        <img
          src="https://www.junaidjamshed.com/media/wysiwyg/W-10.jpg"
          alt=""
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            marginTop: '20px'
          }}
        />
      </Link>
    </Col>

    {/* Image 3 */}
    <Col xs={12} md={6} lg={3} style={{ textAlign: 'center' }}>
      <Link to="sevpic" style={{ color: 'black', textDecoration: 'none' }}>
        <img
          src="https://www.junaidjamshed.com/media/wysiwyg/W-9.jpg"
          alt=""
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            marginTop: '20px'
          }}
        />
      </Link>
    </Col>

    {/* Image 4 */}
    <Col xs={12} md={6} lg={3} style={{ textAlign: 'center' }}>
      <Link to="sevpic" style={{ color: 'black', textDecoration: 'none' }}>
        <img
          src="https://www.junaidjamshed.com/media/wysiwyg/W-8.jpg"
          alt=""
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            marginTop: '20px'
          }}
        />
      </Link>
    </Col>
  </Row>

  {/* Text Section */}
  <Row>
   
  </Row>
</Container>

   
    <br /><br />
    <Useletter/>

    <Foter/>
    </div>// end
  )
}

export default Slider
